<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>edit</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Actualización de datos para débitos</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Correr vencimientos </v-card-title>
              <v-card-text>
                <span class="subtitle">
                  Todos los créditos que:
                  <br />
                  <ul>
                    <li>No tengan ningún pago.</li>
                    <li>
                      Que su primer vencimiento se encuentre entre hoy y un mes
                      siguiente.
                    </li>
                    <li>Que no sean Plan "REN".</li>
                    <li>
                      Todos los aprobados cuya fecha de ingreso no supere los 30
                      días previos a hoy.
                    </li>
                    <li>
                      Todos los activos cuyo día de Fecha de Liquidación sea
                      mayor a 20 de el mes en que nos encontramos.
                    </li>
                  </ul>
                </span>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  dark
                  color="orange"
                  @click="procesarReporteVencimientos()"
                >
                  Generar Reporte&nbsp;
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="green"
                  v-if="this.puedeModificarVencimientos"
                  @click="modificarVencimientos()"
                >
                  Modificar&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Actualizar Fechas de Cobro </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <span class="subtitle">
                      Todas las personas que:
                      <br />
                      <ul>
                        <li>Esten en la Base Anses.</li>
                        <li>Tengan un crédito activo.</li>
                        <li>
                          Cuyo CBU se encuentre en la base y tenga distinto día
                          de cobro.
                        </li>
                      </ul>
                    </span>
                  </v-col>
                  <v-col v-if="transaccionalFechas">
                    <span class="subtitle">
                      <b>Transaccional</b><br />
                      Al indicar que se debe modificar de forma Transaccional
                      los registros se iteran sobre la base, esto puede provocar
                      que algunas funciones del sistema se bloqueen.
                      <ul>
                        <li class="green--text">El proceso es más rápido</li>
                        <li class="red--text">
                          La gestión no es tan completa (Responsable,
                          Comentario)
                        </li>
                      </ul>
                      <h3 class="white--text red lighten-2 text-center">
                        REALIZARLO FUERA DE HORARIO OPERATIVO
                      </h3>
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn dark color="orange" @click="procesarReporteFechas()">
                  Generar Reporte&nbsp;
                </v-btn>
                <v-spacer></v-spacer>
                <v-switch
                  v-if="puedeModificarFechas"
                  class="mr-2"
                  label="Transaccional"
                  v-model="transaccionalFechas"
                  color="indigo"
                ></v-switch>
                <v-btn
                  dark
                  v-if="puedeModificarFechas"
                  color="green"
                  @click="modificarFechas()"
                >
                  Modificar&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title>
                Actualizar Cbus
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <span class="subtitle">
                      Se actualizaran los cbus de las
                      personas que:
                      <ul>
                        <li>Tengan cargado un CBU</li>
                        <li>Tengan crédito Activo.</li>
                        <li>Vector de Pago mayor o igual a 2(dos).</li>
                        <li>No tenga CBU vacío en base Anses.</li>
                      </ul>
                      <b>--IMPORTANTE--</b><br />
                      Se eliminan de la base anses:
                      <ul>
                        <li>
                          Los duplicados que tienen mismo cuil y mismo cbu.
                        </li>
                        <li>
                          De los que tengan mismo cuil y cbu de mismo banco me
                          quedo con los de mayor ingreso.
                        </li>
                        <li>
                          De los que tengan mismo cuil y cbu de distinto banco
                          me quedo con los de mejor orden(Consultar tabla
                          OrdenBancos).
                        </li>
                      </ul>
                    </span>
                  </v-col>
                  <v-col v-if="transaccionalCbus">
                    <span class="subtitle">
                      <b>Transaccional</b><br />
                      Al indicar que se debe modificar de forma Transaccional
                      los registros se iteran sobre la base, esto puede provocar
                      que algunas funciones del sistema se bloqueen.
                      <ul>
                        <li class="green--text">El proceso es más rápido</li>
                        <li class="red--text">
                          La gestión no es tan completa (Responsable,
                          Comentario)
                        </li>
                      </ul>
                      <h3 class="white--text red lighten-2 text-center">
                        REALIZARLO FUERA DE HORARIO OPERATIVO
                      </h3>
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  v-if="!puedeSacarReporteFechasYCbus"
                  dark
                  color="blue"
                  @click="modificarFechasYcbus(false)"
                >
                  Aplanar Base Para Modificaciones&nbsp;
                </v-btn>
                <v-btn
                  v-if="puedeSacarReporteFechasYCbus"
                  dark
                  color="orange"
                  @click="procesarReporteFechasYCbus()"
                >
                  Generar Reporte&nbsp;
                </v-btn>
                <v-spacer></v-spacer>
                <v-switch
                  v-if="puedeModificarFechasYCbus"
                  label="Transaccional"
                  class="mr-2"
                  v-model="transaccionalCbus"
                  color="indigo"
                ></v-switch>
                <v-btn
                  dark
                  color="green"
                  v-if="puedeModificarFechasYCbus"
                  @click="modificarFechasYcbus(true)"
                >
                  Modificar&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Actualizar Subsituación Laboral - Base ANSES</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <span class="subtitle">
                      Se actualizará la subsituación laboral de las personas que:
                      <br />
                      <ul>
                        <li>Esten en la Base Anses.</li>
                        <li>Tengan una subsituación laboral definida en la Base Anses.</li>
                      </ul>
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  dark
                  color="orange"
                  @click="procesarReporteSubsituaciones()"
                >
                  Generar Reporte&nbsp;
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="green"
                  v-if="this.puedeModificarSubsituacionLaboral"
                  @click="modificarSubSituacionLaboral()"
                >
                  Modificar&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Actualizar Día de Cobro - Calendario ANSES </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <span class="subtitle">
                      Se actualizará el día de cobro de los clientes en base a la tabla de Calendario Anses.
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  dark
                  color="orange"
                  @click="procesarReporteDiaCobroAnses()"
                >
                  Generar Reporte&nbsp;
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="green"
                  v-if="this.puedeModificarDiaCobroAnses"
                  @click="modificarDiaCobroAnses()"
                >
                  Modificar&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title>
                Insertar Registros [dbo.AImpactarNormales]
              </v-card-title>
              <v-card-text>
                <span class="subtitle">
                  Se insertaran los registros en la tabla dbo.AImpactarNormales.
                </span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn dark color="green" @click="insertarAImpactarNormales()">
                  Insertar registros&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title>
                Insertar Registros [dbo.ADebitarNormales]
              </v-card-title>
              <v-card-text>
                <span class="subtitle">
                  Se insertaran los registros en la tabla dbo.ADebitarNormales.
                </span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn dark color="green" @click="insertarADebitarNormales()">
                  Insertar registros&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Generar Envio Débitos CardCred </v-card-title>
              <v-card-text>
                <span class="subtitle">
                  Se realizará el envío vía API de los registros de la tabla
                  ADebitarNormales, agrupados por cliente
                </span>
              </v-card-text>
              <v-row>
                <v-col cols="2">
                  <v-autocomplete
                    v-model="empresaId"
                    :items="empresas"
                    autocomplete="disabled"
                    item-text="nombre"
                    item-value="id"
                    label="Casos de la Empresa"
                    placeholder="Seleccione una"
                    :menu-props="{ minWidth: '400' }"
                  ></v-autocomplete>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="fechaDebitoDesde"
                    label="Débito Desde"
                    type="date"
                    prepend-icon="event"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="fechaDebitoHasta"
                    label="Débito Hasta"
                    type="date"
                    prepend-icon="event"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="fechaVtoDesde"
                    label="Vto. Desde "
                    type="date"
                    prepend-icon="event"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="fechaVtoHasta"
                    label="Vto. Hasta"
                    type="date"
                    prepend-icon="event"
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-btn
                    dark
                    color="orange"
                    @click="procesarReporteEnviosCardCred()"
                  >
                    Generar Reporte&nbsp;
                  </v-btn>
                </v-col>
                <v-spacer></v-spacer>
                <v-col>
                  <v-btn
                    dark
                    color="green"
                    v-if="puedeRalizarEnvioCardCred"
                    @click="procesarEnvioCardCredApi()"
                  >
                    Comenzar Envío vía API &nbsp;
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2">
                  <v-text-field
                    v-model="fechaInicioBarrido"
                    label="Inicio Barrido"
                    type="date"
                    prepend-icon="event"
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="diasBarrido"
                    label="Días Barrido"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="horarioBarrido"
                    label="Horario Barrido"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>

              <v-row>
                <v-col>Filtro Archivo Excel</v-col>
              </v-row>

              <v-row align="center">
                <v-col>
                  <v-file-input
                    v-model="archivoFiltroOperaciones"
                    placeholder="Seleccione el archivo Excel"
                    label="Archivo Filtro"
                    prepend-icon="mdi-paperclip"
                  >
                  </v-file-input>
                </v-col>
                <v-col>
                  <v-btn @click="traerListaOperacionesDeExcel()">
                    Cargar Filtro
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="archivoFiltroOperaciones != null">
                <v-col>
                  <v-chip
                    v-if="operacionesFiltro.id == ''"
                    label
                    color="warning"
                  >
                    Presione Cargar Filtro para procesar el archivo
                  </v-chip>

                  <template v-else>
                    <v-chip
                      label
                      color="info"
                      v-if="radiosArchivoExcel == 'Ignorar'"
                    >
                      Hay {{ operacionesFiltro.cantidad }}
                      {{ byNumCredito ? " Créditos" : " Acuerdos" }} en el
                      Filtro pero no se tendrán en cuenta
                    </v-chip>
                    <v-chip
                      label
                      color="green"
                      dark
                      v-if="radiosArchivoExcel == 'SoloCasosFiltro'"
                    >
                      Se incluirán solo los
                      {{ operacionesFiltro.cantidad }}
                      {{ byNumCredito ? " Créditos" : " Acuerdos" }} del Filtro
                    </v-chip>
                    <v-chip
                      label
                      color="red"
                      dark
                      v-if="radiosArchivoExcel == 'ExcluirCasosFiltro'"
                    >
                      Se Excluirán los
                      {{ operacionesFiltro.cantidad }}
                      {{ byNumCredito ? " Créditos" : " Acuerdos" }} del Filtro
                    </v-chip>
                  </template>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Generar Pre-Lotes </v-card-title>
              <v-card-text>
                <span class="subtitle">
                  Se generaran los Id's de PreLote en base a la tabla
                  AImpactarNormales.
                </span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-col cols="2">
                  <v-text-field
                    v-model="separador"
                    label="Separador en archivo"
                  ></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    dark
                    color="green"
                    @click="procesarReporteAImpactarNormales()"
                  >
                    Generar Base&nbsp;
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-btn dark color="green" @click="generarPreLotes()">
                    Generar&nbsp;
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title>
                Actualizar CBU Masivo desde Excel (solo vinculación)
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-alert color="warning" dark dense>
                      El archivo debe tener formato Excel, con una columna con
                      el encabezado CUIL y una columna con el encabezado CBU.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col>
                    <v-file-input
                      v-model="updateCbusMasivoFile"
                      placeholder="Seleccione el archivo Excel"
                      label="Archivo"
                      prepend-icon="mdi-paperclip"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="green"
                  @click="updateCbuMasivoExcel()"
                  :disabled="!updateCbusMasivoFile"
                >
                  Procesar Archivo&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title>
                Cargar CBU Masivo desde Excel (solo altas nuevas)
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-alert color="warning" dark dense>
                      El archivo debe tener formato Excel, con una columna con
                      el encabezado CUIL y una columna con el encabezado CBU.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col>
                    <v-file-input
                      v-model="loadCbusMasivoFile"
                      placeholder="Seleccione el archivo Excel"
                      label="Archivo"
                      prepend-icon="mdi-paperclip"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="green"
                  @click="loadCbuMasivoExcel()"
                  :disabled="!loadCbusMasivoFile"
                >
                  Procesar Archivo&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title>
                Actualizar Día de Cobro Masivo desde Excel
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-alert color="warning" dark dense>
                      El archivo debe tener formato Excel, con una columna con
                      el encabezado CUIL y una columna con el encabezado FECHA
                      NUEVA DIA HABIL.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col>
                    <v-file-input
                      v-model="updateDiasCobroMasivoFile"
                      placeholder="Seleccione el archivo Excel"
                      label="Archivo"
                      prepend-icon="mdi-paperclip"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="green"
                  @click="updateDiasCobroMasivoExcel()"
                  :disabled="!updateDiasCobroMasivoFile"
                >
                  Procesar Archivo&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>
        <v-row>
          <v-container>
            <v-card>
              <v-card-title>
                Actualizar Score Nosis Masivo desde Excel
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-alert color="warning" dark dense>
                      El archivo debe tener formato Excel, con una columna con
                      el encabezado DOCUMENTO y una columna con el encabezado
                      SCO.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col>
                    <v-file-input
                      v-model="updateScoreNosisMasivoFile"
                      placeholder="Seleccione el archivo Excel"
                      label="Archivo"
                      prepend-icon="mdi-paperclip"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="green"
                  @click="updateScoreNosisFromExcelFile()"
                  :disabled="!updateScoreNosisMasivoFile"
                >
                  Procesar Archivo&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Actualizar Lista Excluciones Macro </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-alert color="warning" dark dense>
                      El archivo debe tener formato Excel, con una columna con
                      el encabezado CBU.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col>
                    <v-file-input
                      v-model="updateListaExclucionesMacroFile"
                      placeholder="Seleccione el archivo Excel"
                      label="Archivo"
                      prepend-icon="mdi-paperclip"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="green"
                  @click="updateListaExclucionesMacroFromExcelFile()"
                  :disabled="!updateListaExclucionesMacroFile"
                >
                  Procesar Archivo&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Modificar Medio Cobro (De CBU a TD) </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-alert color="warning" dark dense>
                      El archivo debe tener formato Excel, con las siguientes
                      columnas con el encabezado: EMPRESA, NOMBRE, DOCUMENTO,
                      CREDITO.
                    </v-alert>
                    <v-alert color="warning" dark dense>
                      Los clientes deben tener ya asociada una tarjeta.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col>
                    <v-file-input
                      v-model="updateMedioPagoCbu2TdFile"
                      placeholder="Seleccione el archivo Excel"
                      label="Archivo"
                      prepend-icon="mdi-paperclip"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="green"
                  @click="updateMedioPagoCbu2TdFromExcelFile()"
                  :disabled="!updateMedioPagoCbu2TdFile"
                >
                  Procesar Archivo&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Modificar Medio Cobro (De TD a CBU) </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-alert color="warning" dark dense>
                      El archivo debe tener formato Excel, con las siguientes
                      columnas con el encabezado: EMPRESA, NOMBRE, DOCUMENTO,
                      CREDITO y CBU.
                    </v-alert>
                    <v-alert color="warning" dark dense>
                      Los clientes deben tener ya asociado un CBU.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col>
                    <v-file-input
                      v-model="updateMedioPagoTd2CbuFile"
                      placeholder="Seleccione el archivo Excel"
                      label="Archivo"
                      prepend-icon="mdi-paperclip"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="green"
                  @click="updateMedioPagoTd2CbuFromExcelFile()"
                  :disabled="!updateMedioPagoTd2CbuFile"
                >
                  Procesar Archivo&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Activar/Desactivar CBU </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-alert
                      color="warning"
                      dark
                      dense
                      v-if="activarDesactivarCbu"
                    >
                      El archivo debe tener formato Excel, con las siguientes
                      columnas con el encabezado: EMPRESA, NOMBRE, DOCUMENTO,
                      CREDITO Y CBU.
                    </v-alert>
                    <v-alert color="warning" dark dense v-else>
                      El archivo debe tener formato Excel, con las siguientes
                      columnas con el encabezado: EMPRESA, NOMBRE, DOCUMENTO Y
                      CREDITO.
                    </v-alert>
                    <v-alert
                      color="warning"
                      dark
                      dense
                      v-if="!activarDesactivarCbu"
                    >
                      Los clientes deben tener ya asociado un CBU.
                    </v-alert>
                    <v-alert color="warning" dark dense v-else>
                      Los clientes NO deben tener ya asociado un CBU.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="auto">
                    <v-switch
                      v-model="activarDesactivarCbu"
                      :label="activarDesactivarCbu ? 'Activar' : 'Desactivar'"
                    ></v-switch>
                  </v-col>
                  <v-col>
                    <v-file-input
                      v-model="desactivarCbuFile"
                      placeholder="Seleccione el archivo Excel"
                      label="Archivo"
                      prepend-icon="mdi-paperclip"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="red"
                  @click="procesarBajaCbu()"
                  :disabled="!desactivarCbuFile"
                >
                  Procesar Baja
                </v-btn>
                <v-btn
                  dark
                  color="green"
                  @click="desactivarCbuFromExcelFile()"
                  :disabled="!desactivarCbuFile"
                >
                  Procesar Archivo
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title> Activar/Desactivar TD </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-alert color="warning" dark dense>
                      (Procesar Archivo) El archivo debe tener formato Excel,
                      con las siguientes columnas con el encabezado: EMPRESA,
                      NOMBRE, DOCUMENTO, CREDITO.
                    </v-alert>
                    <v-alert color="warning" dark dense>
                      (Procesar Baja) El archivo debe tener formato Excel, con
                      las siguientes columnas con el encabezado: EMPRESA,
                      NOMBRE, DOCUMENTO, CREDITO, ULTIMOS4DIGITOS.
                    </v-alert>
                    <v-alert
                      color="warning"
                      dark
                      dense
                      v-if="!activarDesactivarTd"
                    >
                      Los clientes deben tener ya asociado una Tarjeta.
                    </v-alert>
                    <v-alert color="warning" dark dense v-else>
                      Los clientes deben NO tener ya asociado una Tarjeta.
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="auto">
                    <v-switch
                      v-model="activarDesactivarTd"
                      :label="activarDesactivarTd ? 'Activar' : 'Desactivar'"
                    ></v-switch>
                  </v-col>
                  <v-col>
                    <v-file-input
                      v-model="desactivarTdFile"
                      placeholder="Seleccione el archivo Excel"
                      label="Archivo"
                      prepend-icon="mdi-paperclip"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="red"
                  @click="procesarBajaTD()"
                  :disabled="!desactivarTdFile"
                >
                  Procesar Baja
                </v-btn>
                <v-btn
                  dark
                  color="green"
                  @click="desactivarTdFromExcelFile()"
                  :disabled="!desactivarTdFile"
                >
                  Procesar Archivo
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

        <v-row>
          <v-container>
            <v-card>
              <v-card-title>
                Actualizar Empleadores Masivo desde Excel
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <v-alert color="warning" dark dense>
                      El archivo debe tener formato Excel, con las siguientes columnas con el encabezado: 
                      ID, CUIT, SITUACION LABORAL, SUBSITUACION LABORAL, ACTIVIDAD LABORAL Y ORDEN.
                    </v-alert>
                    <v-alert color="warning" dark dense>
                      <ul>
                        <li>La columna ID corresponde al registro de PersonasEmpleos que se desea corregir.</li>
                        <li>Las celdas vacías no modificarán los datos existentes.</li>
                      </ul>
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col>
                    <v-file-input
                      v-model="updateEmpleadoresMasivoFile"
                      placeholder="Seleccione el archivo Excel"
                      label="Archivo"
                      prepend-icon="mdi-paperclip"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  dark
                  color="green"
                  @click="updateEmpleadoresMasivoExcel()"
                  :disabled="!updateEmpleadoresMasivoFile"
                >
                  Procesar Archivo&nbsp;
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-row>

      </v-card-text>
    </v-card>

    <v-card class="mt-4">
      <v-card-title
        ><v-icon>edit</v-icon> Cashflow FotoSituacionInicioMes</v-card-title
      >
      <v-card-text>
        <v-container>
          <v-row> Ajustar saldos e importes de FotoSituacionInicioMes </v-row>
          <v-row>
            <ul>
              <li>
                Asegurese de que se corrio el proceso de la generacion de la
                tabla FotoSituacionInicioMes
              </li>
            </ul>
            <v-spacer></v-spacer>
            <v-btn dark color="purple" @click="ajustarCashflow()">
              Ajustar&nbsp;
            </v-btn>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-card class="mt-4">
      <v-card-title
        ><v-icon>edit</v-icon> Generación de Cuotas Cuponizate
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-alert color="warning" dark dense>
              Se generarán las cuotas de los créditos CUPONIZATE del més próximo
            </v-alert></v-row
          >
          <v-row>
            <v-spacer></v-spacer>
            <v-btn dark color="orange" @click="procesarReporteCuponizate()">
              Generar Reporte&nbsp;
            </v-btn>
            <v-btn
              dark
              color="green"
              @click="generarCuponizate()"
              v-if="puedeGenerarCuponizara"
            >
              Generar Cuotas&nbsp;
            </v-btn>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>
<script>
import { http } from "@/axios";

import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      loading: false,
      puedeModificarVencimientos: false,
      puedeSacarReporteFechasYCbus: false,
      puedeModificarFechasYCbus: false,
      puedeModificarFechas: false,
      puedeGenerarPreLotes: false,
      puedeModificarDiaCobroAnses: false,
      puedeModificarSubsituacionLaboral: false,
      transaccionalCbus: false,
      transaccionalFechas: false,
      updateCbusMasivoFile: null,
      loadCbusMasivoFile: null,
      updateDiasCobroMasivoFile: null,
      updateScoreNosisMasivoFile: null,
      updateListaExclucionesMacroFile: null,
      updateMedioPagoCbu2TdFile: null,
      updateMedioPagoTd2CbuFile: null,
      updateEmpleadoresMasivoFile: null,
      activarDesactivarCbu: true,
      activarDesactivarTd: true,
      desactivarCbuFile: null,
      desactivarTdFile: null,
      puedeRalizarEnvioCardCred: false,
      fechaDebitoDesde: null,
      fechaDebitoHasta: null,
      fechaVtoDesde: null,
      fechaVtoHasta: null,
      fechaInicioBarrido: null,
      diasBarrido: null,
      horarioBarrido: null,
      separador: ";",
      empresas: [],
      archivoFiltroOperaciones: [],
      operacionesFiltro: [],
      byNumCredito: "Creditos",
      radiosArchivoExcel: "Ignorar",
      empresaId: 1,
      puedeGenerarCuponizara: false,
    };
  },
  async created() {
    this.vtoHasta = this.$moment().format("YYYY-MM-DD");
    this.loadEmpresas();
  },
  computed: {
    ...mapGetters([
      "activeTask",
      "getActionFromLink",
      "user",
      "closeRelatedTasks",
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    componentsLoading: function () {
      return (
        this.loadingCreditosEnMora ||
        this.loadingTelefonos ||
        this.loadingGestionesTelefonicas ||
        this.loadingOtrasGestiones
      );
    },
  },
  watch: {
    archivoFiltroOperaciones() {
      if (this.archivoFiltroOperaciones == null)
        this.operacionesFiltro = { id: "", cantidad: 0 };
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get("empresas"); // traigo todas
        this.empresas = result.list;
        this.empresaId = this.empresas[0].id;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async procesarReporteVencimientos() {
      var self = this;

      try {
        self.loading = true;

        this.setReporteActivo({ reporte: "CorrerVencimientosCreditos.trdp" });
        window.open("/report-viewer");

        this.puedeModificarVencimientos = true;
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async modificarVencimientos() {
      var ok = confirm("¿Está seguro que quiere modificar los vencimientos?");

      if (!ok) {
        return;
      }

      var self = this;

      self.loading = true;

      try {
        await http
          .post(
            "archivosDebito/updatevencimientoscreditos",
            JSON.stringify({ user: "Admin" })
          )
          .then((resp) => {
            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Vencimientos modificados correctamente");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        self.alertError(error);
      }

      self.loading = false;
    },
    async procesarReporteFechasYCbus() {
      var self = this;

      try {
        self.loading = true;

        this.setReporteActivo({ reporte: "CambiosFechasYCbus.trdp" });
        window.open("/report-viewer");

        this.puedeModificarFechasYCbus = true;
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async procesarReporteEnviosCardCred() {
      var self = this;

      if (!this.fechaDebitoDesde || !this.fechaDebitoHasta) {
        this.alertError(
          "Por favor, seleccione las fechas de débito Desde/Hasta."
        );
        return;
      }

      // if (!this.fechaVtoDesde || !this.fechaVtoHasta) {
      //   this.alertError(
      //     "Por favor, seleccione las fechas de vencimiento Desde/Hasta."
      //   );
      //   return;
      // }

      try {
        self.loading = true;

        const vtoDesdeParam = this.fechaVtoDesde || "1/1/1900";
        const vtoHastaParam = this.fechaVtoHasta || "31/12/2050";

        let params = [];
        params.push({
          EmpresaId: this.empresaId,
          FechaDesde: this.fechaDebitoDesde,
          FechaHasta: this.fechaDebitoHasta,
          InicioBarrido: this.fechaInicioBarrido,
          DiasBarrido: this.diasBarrido,
          HoraBarrido: this.horarioBarrido,
          OperacionesFiltroId: this.operacionesFiltro.id,
          VtoDesde: vtoDesdeParam,
          VtoHasta: vtoHastaParam,
        });

        this.setReporteActivo({
          reporte: "EnvioCardCredAPI.trdp",
          params: params,
        });
        window.open("/report-viewer");

        this.puedeRalizarEnvioCardCred = true;
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async modificarFechasYcbus(update) {
      var self = this;

      self.loading = true;

      var params = {
        user: this.user.nombre,
        modifica: update,
        transactional: this.transaccionalCbus,
      };

      if (update) {
        var ok = confirm(
          "¿Está seguro que quiere modificar los cbus?"
        );

        if (!ok) {
          return;
        }

        try {
          await http
            .post(
              "archivosDebito/updatecbusyfechas",
              JSON.stringify({ params: params })
            )
            .then((resp) => {
              if (resp.error) {
                self.alertError(resp.error);
              } else {
                self.alertSuccess(
                  "Cbus modificados correctamente"
                );
              }
            })
            .catch((e) => {
              self.alertError(e);
            });
        } catch (error) {
          self.alertError(error);
        }
      } else {
        try {
          await http
            .post(
              "archivosDebito/updatecbusyfechas",
              JSON.stringify({ params: params })
            )
            .then((this.puedeSacarReporteFechasYCbus = true))
            .catch((e) => {
              self.alertError(e);
              this.puedeSacarReporteFechasYCbus = false;
            });
        } catch (error) {
          this.puedeSacarReporteFechasYCbus = false;
          self.alertError(error);
        }
      }

      self.loading = false;
    },
    async procesarReporteSubsituaciones() {
      var self = this;

      try {
        self.loading = true;

        this.setReporteActivo({ reporte: "CambiosSubSituacionLaboralAnses.trdp" });
        window.open("/report-viewer");

        this.puedeModificarSubsituacionLaboral = true;
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async modificarSubSituacionLaboral() {
      var ok = confirm("¿Está seguro que quiere actualizar las subsituaciones laborales?");

      if (!ok) {
        return;
      }

      var self = this;
      self.loading = true;

      try {
        await http
          .post(
            "archivosDebito/updatesubsituacionlaboral",
            { }
          )
          .then((resp) => {
            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Subsituaciones laborales actualizadas correctamente");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        self.alertError(error);
      }

      self.loading = false;
    },
    async procesarReporteDiaCobroAnses() {
      var self = this;

      try {
        self.loading = true;

        this.setReporteActivo({ reporte: "CambiosDiaCobroAnses.trdp" });
        window.open("/report-viewer");

        this.puedeModificarDiaCobroAnses = true;
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async modificarDiaCobroAnses() {
      var ok = confirm("¿Está seguro que quiere actualizar los días de cobro?");

      if (!ok) {
        return;
      }

      var self = this;
      self.loading = true;

      try {
        await http
          .post(
            "archivosDebito/updatediacobroanses",
            { }
          )
          .then((resp) => {
            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Días de cobro actualizados correctamente");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        self.alertError(error);
      }

      self.loading = false;
    },
    async procesarReporteFechas() {
      var self = this;

      try {
        self.loading = true;

        this.setReporteActivo({ reporte: "UpdateFechasParaDebitos.trdp" });
        window.open("/report-viewer");

        this.puedeModificarFechas = true;
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async modificarFechas() {
      var ok = confirm("¿Está seguro que quiere modificar las fechas?");

      if (!ok) {
        return;
      }

      var self = this;

      self.loading = true;

      var params = {
        user: this.user.nombre,
        transactional: this.transaccionalFechas,
      };

      try {
        await http
          .post(
            "archivosDebito/updatefechasdebito",
            JSON.stringify({ params: params })
          )
          .then((resp) => {
            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Fechas modificadas correctamente");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        self.alertError(error);
      }

      self.loading = false;
    },
    async generarPreLotes() {
      var ok = confirm(
        "¿Está seguro que quiere generar los PreLotes? Asegurese de haber hecho todos los pasos previos."
      );

      if (!ok) {
        return;
      }

      var self = this;

      self.loading = true;

      try {
        await http
          .post(
            "archivosDebito/generarPreLotes",
            JSON.stringify({ user: this.user.nombre })
          )
          .then((resp) => {
            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se Generaron Correctamente los Pre Lotes");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        self.alertError(error);
      }

      self.loading = false;
    },
    async traerListaOperacionesDeExcel() {
      if (!this.archivoFiltroOperaciones) return;
      if (!this.archivoFiltroOperaciones.name.includes(".xls")) {
        this.archivoFiltroOperaciones = [];
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;
      let formData = new FormData();

      formData.append("archivo", this.archivoFiltroOperaciones);

      try {
        var listaOps = await http.post(
          "archivosDebito/excelAFiltroOperaciones",
          formData
        );
        console.log(listaOps);
        this.operacionesFiltro = listaOps;
        this.radiosArchivoExcel = "SoloCasosFiltro";
      } catch (error) {
        // Error
        this.alertError(error);
      }

      /* http.post('archivosDebito/excelAFiltroOperaciones', formData)
        .then(resp => {
            Vue.$log.debug(resp);
        })
        .catch((e) => {
            this.alertError(e)
        }); */

      this.loading = false;
    },
    async procesarEnvioCardCredApi() {
      if (!this.fechaDebitoDesde || !this.fechaDebitoHasta) {
        this.alertError(
          "Por favor, seleccione las fechas de débito Desde/Hasta. "
        );
        return;
      }

      // if (!this.fechaVtoDesde || !this.fechaVtoHasta) {
      //   this.alertError(
      //     "Por favor, seleccione las fechas de vencimiento Desde/Hasta."
      //   );
      //   return;
      // }

      var ok = confirm(
        "¿Confirma el inicio del envío de los débitos a CardCred via API?."
      );

      if (!ok) {
        return;
      }

      var self = this;

      self.loading = true;

      try {
        const vtoDesdeParam = this.fechaVtoDesde || "1/1/1900";
        const vtoHastaParam = this.fechaVtoHasta || "31/12/2050";

        await http
          .post(
            "archivosDebito/enviocardcredapimasivo",
            JSON.stringify({
              empresaId: this.empresaId,
              fechaDesde: this.fechaDebitoDesde,
              fechaHasta: this.fechaDebitoHasta,
              inicioBarrido: this.fechaInicioBarrido,
              diasBarrido: this.diasBarrido,
              horarioBarrido: this.horarioBarrido,
              filtroOperacionesId: this.operacionesFiltro.id,
              user: this.user.nombre,
              vtoDesde: vtoDesdeParam,
              vtoHasta: vtoHastaParam,
            })
          )
          .then((resp) => {
            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("El envío se realizó correctamente");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        self.alertError(error);
      }

      self.loading = false;
    },
    async procesarReporteAImpactarNormales() {
      var self = this;

      try {
        self.loading = true;

        console.log(this.filtro);

        await http
          .post(
            "filegeneration/aimpactarnormales",
            JSON.stringify({ user: this.user.name, separador: this.separador })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se generó correctamente el archivo. Aguarde unos instantes mientras se descarga el archivo..."
              );

              self.loading = true;
              self.downloadFile(resp, "TablaAImpactarNormales.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }

      self.loading = false;
    },
    async insertarAImpactarNormales() {
      var ok = confirm("¿Está seguro que quiere insertar los registros?");

      if (!ok) {
        return;
      }

      var self = this;

      self.loading = true;

      try {
        await http
          .post(
            "archivosDebito/insertAImpactarNormales",
            JSON.stringify({ user: this.user.nombre })
          )
          .then((resp) => {
            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Tabla dbo.AImpactarNormales creada correctamente"
              );
              this.procesarReporteAImpactarNormales();
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        self.alertError(error);
      }

      self.loading = false;
    },
    async insertarADebitarNormales() {
      var ok = confirm("¿Está seguro que quiere insertar los registros?");

      if (!ok) {
        return;
      }

      var self = this;

      self.loading = true;

      try {
        await http
          .post(
            "archivosDebito/insertADebitarNormales",
            JSON.stringify({ user: this.user.nombre })
          )
          .then((resp) => {
            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Tabla dbo.ADebitarNormales creada correctamente"
              );
              this.procesarReporteADebitarNormales();
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        self.alertError(error);
      }

      self.loading = false;
    },
    async procesarReporteADebitarNormales() {
      var self = this;

      try {
        self.loading = true;

        console.log(this.filtro);

        await http
          .post(
            "filegeneration/adebitarnormales",
            JSON.stringify({ user: this.user.name, separador: this.separador })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se generó correctamente el archivo. Aguarde unos instantes mientras se descarga el archivo..."
              );

              self.loading = true;
              self.downloadFile(resp, "TablaADebitarNormales.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }

      self.loading = false;
    },
    async ajustarCashflow() {
      var self = this;

      self.loading = true;

      try {
        await http
          .post(
            "archivosDebito/ajustarcashflow",
            JSON.stringify({ user: this.user.nombre })
          )
          .then((resp) => {
            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Proceso realizado correctamente");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        self.alertError(error);
      }

      self.loading = false;
    },

    async updateCbuMasivoExcel() {
      if (
        !this.updateCbusMasivoFile ||
        !this.updateCbusMasivoFile.name.includes(".xls")
      ) {
        this.updateCbusMasivoFile = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }
      var self = this;
      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.updateCbusMasivoFile);

      // try {
      //   var result = await http.post(
      //     "archivosDebito/update-cbu-masivo-excel",
      //     formData
      //   );

      //   this.alertSuccess(
      //     `Se procesaron ${result.casosExitosos.length} casos con éxito y fallaron ${result.casosFallidos.length} casos.`
      //   );

      //   self.loading = true;
      //   self.downloadFile(result, "UpdateCBUsFromExcel.txt");
      //   self.loading = false;

      try {
        await http
          .post("archivosDebito/update-cbu-masivo-excel", formData)
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se procesó correctamenta el archivo. Aguarde unos instantes mientras se descarga el resultado..."
              );

              self.loading = true;
              self.downloadFile(resp, "UpdateCBUsFromExcel.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadCbuMasivoExcel() {
      if (
        !this.loadCbusMasivoFile ||
        !this.loadCbusMasivoFile.name.includes(".xls")
      ) {
        this.loadCbusMasivoFile = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }
      var self = this;
      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.loadCbusMasivoFile);

      try {
        await http
          .post("archivosDebito/load-cbu-masivo-excel", formData)
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se procesó correctamenta el archivo. Aguarde unos instantes mientras se descarga el resultado..."
              );

              self.loading = true;
              self.downloadFile(resp, "LoadCBUsFromExcel.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async updateDiasCobroMasivoExcel() {
      if (
        !this.updateDiasCobroMasivoFile ||
        !this.updateDiasCobroMasivoFile.name.includes(".xls")
      ) {
        this.updateDiasCobroMasivoFile = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.updateDiasCobroMasivoFile);

      try {
        var result = await http.post(
          "archivosDebito/update-diacobro-masivo-excel",
          formData
        );

        this.alertSuccess(
          `Se procesaron ${result.casosExitosos.length} casos con éxito y fallaron ${result.casosFallidos.length} casos.`
        );
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async updateScoreNosisFromExcelFile() {
      if (
        !this.updateScoreNosisMasivoFile ||
        !this.updateScoreNosisMasivoFile.name.includes(".xls")
      ) {
        this.updateScoreNosisMasivoFile = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.updateScoreNosisFromExcelFile);

      try {
        var result = await http.post(
          "archivosDebito/update-score-nosis-from-excel",
          formData
        );

        this.alertSuccess(
          `Se procesaron ${result.casosExitosos.length} casos con éxito y fallaron ${result.casosFallidos.length} casos.`
        );
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async updateListaExclucionesMacroFromExcelFile() {
      if (
        !this.updateListaExclucionesMacroFile ||
        !this.updateListaExclucionesMacroFile.name.includes(".xls")
      ) {
        this.updateListaExclucionesMacroFile = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.updateListaExclucionesMacroFile);

      try {
        await http.post(
          "archivosDebito/update-exclusiones-macro-from-excel",
          formData
        );

        this.alertSuccess("Proceso finalizado correctamente.");
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async updateMedioPagoCbu2TdFromExcelFile() {
      var self = this;

      if (
        !this.updateMedioPagoCbu2TdFile ||
        !this.updateMedioPagoCbu2TdFile.name.includes(".xls")
      ) {
        this.updateMedioPagoCbu2TdFile = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.updateMedioPagoCbu2TdFile);
      formData.append("separador", this.separador);

      try {
        await http
          .post("archivosDebito/update-mediopago-cbu-a-td", formData)
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se procesó correctamenta el archivo. Aguarde unos instantes mientras se descarga el resultado..."
              );

              self.loading = true;
              self.downloadFile(resp, "CambioMasivoMedioPago_CBU_a_TD.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async updateMedioPagoTd2CbuFromExcelFile() {
      var self = this;

      if (
        !this.updateMedioPagoTd2CbuFile ||
        !this.updateMedioPagoTd2CbuFile.name.includes(".xls")
      ) {
        this.updateMedioPagoTd2CbuFile = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.updateMedioPagoTd2CbuFile);
      formData.append("separador", this.separador);

      try {
        await http
          .post("archivosDebito/update-mediopago-td-a-cbu", formData)
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se procesó correctamenta el archivo. Aguarde unos instantes mientras se descarga el resultado..."
              );

              self.loading = true;
              self.downloadFile(resp, "CambioMasivoMedioPago_TD_a_CBU.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async desactivarCbuFromExcelFile() {
      var self = this;

      if (
        !this.desactivarCbuFile ||
        !this.desactivarCbuFile.name.includes(".xlsx")
      ) {
        this.desactivarCbuFile = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.desactivarCbuFile);
      formData.append("activar", this.activarDesactivarCbu);
      formData.append("separador", this.separador);

      try {
        await http
          .post("archivosDebito/activar-desactivar-mediopago-cbu", formData)
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se procesó correctamenta el archivo. Aguarde unos instantes mientras se descarga el resultado..."
              );

              self.loading = true;
              self.downloadFile(resp, "DesactivacionMedioPago_CBU.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async desactivarTdFromExcelFile() {
      var self = this;

      if (
        !this.desactivarTdFile ||
        !this.desactivarTdFile.name.includes(".xlsx")
      ) {
        this.desactivarTdFile = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.desactivarTdFile);
      formData.append("activar", this.activarDesactivarTd);
      formData.append("separador", this.separador);

      try {
        await http
          .post("archivosDebito/activar-desactivar-mediopago-td", formData)
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se procesó correctamenta el archivo. Aguarde unos instantes mientras se descarga el resultado..."
              );

              self.loading = true;
              self.downloadFile(resp, "DesactivacionMedioPago_TD.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async procesarBajaCbu() {
      var self = this;
      if (
        !this.desactivarCbuFile ||
        !this.desactivarCbuFile.name.includes(".xlsx")
      ) {
        this.desactivarCbuFile = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.desactivarCbuFile);
      formData.append("activar", this.activarDesactivarCbu);
      formData.append("separador", this.separador);

      try {
        await http
          .post("archivosDebito/procesar-baja-cbu", formData)
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se procesó correctamenta el archivo. Aguarde unos instantes mientras se descarga el resultado..."
              );

              self.loading = true;
              self.downloadFile(resp, "Baja_CBU.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async updateEmpleadoresMasivoExcel() {
      if (
        !this.updateEmpleadoresMasivoFile ||
        !this.updateEmpleadoresMasivoFile.name.includes(".xls")
      ) {
        this.updateEmpleadoresMasivoFile = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.updateEmpleadoresMasivoFile);

      try {
        var result = await http.post(
          "archivosDebito/update-empleadores-masivo-excel",
          formData
        );

        this.alertSuccess(
          `Se procesaron ${result.casosExitosos.length} casos con éxito y fallaron ${result.casosFallidos.length} casos.`
        );
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async downloadFile(file, renameTo) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = "";
      base64String = btoa(file.fullPath);

      http
        .get("filemanagement/getfilebypath/" + base64String)
        .then((resp) => {
          let dataType = "";
          switch (resp.extension) {
            case ".doc":
            case ".docx":
            case ".DOC":
            case ".DOCX":
              dataType = "data:application/vnd.ms-word";
              break;
            case ".pdf":
            case ".PDF":
              dataType = "data:application/pdf";
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(renameTo, arrayBuffer, dataType);
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },

    async procesarBajaTD() {
      var self = this;

      if (
        !this.desactivarTdFile ||
        !this.desactivarTdFile.name.includes(".xlsx")
      ) {
        this.desactivarTdFile = null;
        this.alertWarning("Debe elegir un archivo Excel.");
        return;
      }

      this.loading = true;

      let formData = new FormData();
      formData.append("excelFile", this.desactivarTdFile);
      formData.append("activar", this.activarDesactivarTd);
      formData.append("separador", this.separador);

      try {
        await http
          .post("archivosDebito/procesar-baja-td", formData)
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se procesó correctamenta el archivo. Aguarde unos instantes mientras se descarga el resultado..."
              );

              self.loading = true;
              self.downloadFile(resp, "Baja_TD.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async procesarBase() {
      // validaciones
      // if(!this.validar())
      // {
      //     return;
      // }

      var self = this;

      try {
        self.loading = true;

        console.log(this.filtro);

        await http
          .post(
            "filegeneration/enviosms",
            JSON.stringify({ parametros: this.filtro })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se generó correctamente el archivo. Aguarde unos instantes mientras se descarga el archivo..."
              );

              self.loading = true;
              self.downloadFile(resp, "EnvioSms.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    getFirstDayOfNextMonth() {
      // Obtener la fecha actual
      const today = new Date();

      // Obtener el año y mes actuales
      let year = today.getFullYear();
      let month = today.getMonth(); // Los meses son 0-indexados (0 para enero, 11 para diciembre)

      // Incrementar el mes en 1
      month += 1;

      // Si el mes es diciembre, ajustar el año y el mes
      if (month > 11) {
        month = 0; // Enero
        year += 1; // Incrementar el año
      }

      // Crear una nueva fecha con el año, mes y el primer día del mes
      const firstDayOfNextMonth = new Date(year, month, 1);

      return firstDayOfNextMonth;
    },
    async procesarReporteCuponizate() {
      var self = this;

      try {
        self.loading = true;

        // crear variable con el primero del mes siguiente

        let params = [];
        params.push({
          EmpresaId: 2,
          FechaGeneracion: this.getFirstDayOfNextMonth(),
          SoloReporte: true,
        });

        this.setReporteActivo({
          reporte: "CuotasCuponizateAGenerar.trdp",
          params: params,
        });
        window.open("/report-viewer");

        this.puedeGenerarCuponizara = true;
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
    async generarCuponizate() {
      // validaciones

      var self = this;

      try {
        self.loading = true;

        await http
          .post(
            "Creditos/generacioncuotascuponizate",
            JSON.stringify({ Fecha: null })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess("Se generaron correctamente las cuotas");
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
  },
};
</script>
